import type { IconData } from '@stacksjs/iconify-core'

export const otherUiScanner: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M0 4.5V0h4.5v2H2v2.5zM4.5 16H0v-4.5h2V14h2.5zM16 16v-4.5h-2V14h-2.5v2zM11.5 0H16v4.5h-2V2h-2.5zM16 6H0v4h16z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default otherUiScanner
